export function redirectTo(url: string) {
  window.location.assign(url);
}

export const navigateTo = redirectTo;
